module.exports = __webpack_public_path__ + "static/josemiguel-93b9c36f0ed9a443694baa38ebef61d0.jpg";